import PropTypes from 'prop-types';
import React from 'react';

class Dropdown extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			active: false,
		};

		this.selectRef = React.createRef();
		this.input = React.createRef();
	}

	toggleSelect = () => {
		this.setState({
			active: !this.state.active,
		});
	};

	changeOption = (key, label) => {
		this.selectRef.current.innerHTML = label;
		this.input.current.value = parseInt(key);
		this.input.current.dispatchEvent(
			new Event('input', {
				bubbles: true,
			}),
		);
	};

	render() {
		const { name, options, defaultValue, placeholder, handleChange } = this.props;
		const selectValues = [];

		Object.keys(options).map((key) => selectValues.push(options[key].label));

		return (
			<div className={'dropdown' + (this.state.active ? ' active' : '')} onClick={(e) => this.toggleSelect(e)}>
				<div className="dropdown__select">
					<span ref={this.selectRef}>{defaultValue !== false ? selectValues[defaultValue] : placeholder}</span>
					<i className="select__icon"></i>
				</div>
				<ul className="dropdown__menu">
					{Object.keys(options).map((key) => (
						<li className={defaultValue === parseInt(key) ? 'active' : ''} key={`option_${key}`} onClick={() => this.changeOption(key, options[key].label)}>
							{options[key].label}
						</li>
					))}
				</ul>
				<input type="text" ref={this.input} name={name} onInput={handleChange} value={defaultValue} />
			</div>
		);
	}
}

export default Dropdown;

Dropdown.propTypes = {
	defaultValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
	handleChange: PropTypes.func,
	name: PropTypes.number,
	options: PropTypes.array,
	placeholder: PropTypes.string,
};
